import React from 'react';
import { WelcomeMessage } from '../WelcomeMessage';

interface WelcomeMessageComponentProps {
  content: {};
  onSendMessage?: (content: string) => void;
}

const WelcomeMessageComponent: React.FC<WelcomeMessageComponentProps> = ({ onSendMessage }) => {
  return <WelcomeMessage onSendMessage={onSendMessage || (() => {})} />;
};

export default WelcomeMessageComponent;
